import { render } from "./PayoutsComponent.vue?vue&type=template&id=6b8a73a8"
import script from "./PayoutsComponent.vue?vue&type=script&lang=js"
export * from "./PayoutsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__